import { Trans, useTranslation } from 'next-i18next/pages';
import { useMemo } from 'react';

import { ConnectionInfo } from '@pflegia/types/common/match/dialog';

import { useJobPositionsFeatures } from '@domains/job-board/hooks/use-job-positions-features';

import Carousel from '@shared/components/carousel/Carousel';

import CarouselJobCard, { CarouselJobCardJob } from './CarouselJobCard';

const MIN_JOBS_TO_RENDER = 2;

export interface CarouselJob {
  id: string;
  jobPosition: CarouselJobCardJob;
}

interface OtherJobsCarouselProps {
  jobs: CarouselJob[];
  openDialog: (connectionInfo: ConnectionInfo) => void;
}

const OtherJobsCarousel: React.FC<OtherJobsCarouselProps> = ({ jobs, openDialog }) => {
  const { t } = useTranslation('jobDetails');
  const jobIds = useMemo(() => jobs.map(({ jobPosition }) => jobPosition.id), [jobs]);
  const { featureByJobPositionId, loading: featuresLoading } = useJobPositionsFeatures(jobIds);

  if (jobs.length < MIN_JOBS_TO_RENDER) return null;

  return (
    <div className='my-4 rounded-2xl bg-blue-100 p-4 lg:p-12'>
      <h3 className='text-default mb-6 text-xl font-bold md:text-2xl'>
        <Trans
          t={t}
          i18nKey='abTestNewComponents.otherJobsCarousel.title'
          components={{ span: <span className='font-handwriting text-primary text-2xl font-normal md:text-3xl' /> }}
        />
      </h3>

      <Carousel hideGradient>
        {jobs.map(({ id, jobPosition }) => (
          <CarouselJobCard
            key={id}
            job={jobPosition}
            featuresBadges={{ ...(featureByJobPositionId[jobPosition.id] ?? {}), loading: featuresLoading }}
            openDialog={openDialog}
          />
        ))}
      </Carousel>
    </div>
  );
};

export default OtherJobsCarousel;
